const state = () => ({
  showError: false,
  message: '',
  variant: 'danger'
})

const mutations = {
  showError (state, { message, variant }) {
    if (variant) {
      state.variant = variant
    }
    state.message = message
    state.showError = true
  },
  dismissError (state) {
    state.variant = 'danger'
    state.showError = false
    state.message = ''
  }
}

export default { namespaced: true, state, mutations }
